import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import { Col, Container, Row, Form, FloatingLabel } from "react-bootstrap";
import { Typeahead, Hint } from "react-bootstrap-typeahead";
import { useSelector, useDispatch } from "react-redux";
import { IconRefresh } from "@tabler/icons-react";

import Footer from "../components/Footer";
import { logout } from "../actions/auth";

import logoAtria from "../assets/images/logos/atria-color.png";
import logoAtriaLateral from "../assets/images/logos/logo-atria-lateral.svg";
import { getSucursales, updateSucursalSelection } from "../actions/sucursales";
import Solicitudes from "../components/Solicitudes";
import Seguros from "../components/seguro/Seguros";
import Loading from "../components/Loading";
import ModalErrores from "../components/ModalErrores";
import { useEffect } from "react";
import { menu } from "../actions/menuHome";
import Dashboard from "../components/Dashboard";
import BarraPerfil from "../components/BarraPerfil";
import AlertaMessage from "../components/AlertaMessage";
import { resetCotizadorSeguro } from "../actions/seguros/cotizadorSeguros";
import { getSecurityKey } from "../helpers/SecurityKey";
import { geolocalizacion } from "../helpers/functionGlobal";

const HomeScreen = () => {
  const [vistaMostrar, setVistaMostrar] = useState();
  const [updateSolicitud, setUpdateSolicitud] = useState(false);
  const dispatch = useDispatch();
  const currentUser = useSelector((state) => state.auth);
  const { isLoggedIn, user } = currentUser;
  const sucursalSelec = useSelector((state) => state.sucursalSelection);
  const { Clave } = sucursalSelec.sucursalSeleccionada || {};

  const sucursales = useSelector((state) => state.obtencionSucursales);

  const loading = useSelector((state) => state.loading);
  const obtencionError = useSelector((state) => state.mensajeError);
  const { isError } = obtencionError;
  const { tipoError, mensajeError } = obtencionError.dataError;

  const obtencionMenu = useSelector((state) => state.menu);
  const { menuHome } = obtencionMenu;
  const [sucursal, setSucursal] = useState(Clave || "");

  const obtencionDashboard = useSelector((state) => state.dashboard);
  const { fullName, profilePicture } = obtencionDashboard.dataDashboard;

  const obtencionAlerta = useSelector((state) => state.alertMessage);

  const securityKey = getSecurityKey();

  useEffect(() => {
    mostrarSolicidutes(menuHome, false);
    dispatch(resetCotizadorSeguro());

    // Solo cargar sucursales si no están ya cargadas
    if (!sucursales.isSucursal || sucursales.dataSucursales.length === 0) {
      geolocalizacion().then((res) => {
        dispatch(getSucursales(user.correo, securityKey, res.lt, res.lg));
      });
    }
  }, []);

  // Actualizar estado local cuando cambie la sucursal seleccionada
  useEffect(() => {
    if (sucursalSelec.sucursalSeleccionada?.Clave) {
      setSucursal(sucursalSelec.sucursalSeleccionada.Clave);
    }
  }, [sucursalSelec.sucursalSeleccionada]);

  const handleLogout = () => {
    dispatch(logout());
  };

  const optionSucursales = sucursales.isSucursal
    ? sucursales.dataSucursales.map((sucursal, index) => {
        return (
          <option key={index} value={sucursal.Clave}>
            {sucursal.Proveedor}
          </option>
        );
      })
    : "";

  const cambioSucursal = (e) => {
    const sucursalSelect = e.target.value;
    const dataSucursal = sucursales.dataSucursales.find(
      (element) => element.Clave === sucursalSelect,
    );
    dispatch(updateSucursalSelection(dataSucursal));
    setSucursal(sucursalSelect);
  };

  const mostrarSolicidutes = (e, shouldRefresh = true) => {
    setVistaMostrar(e);
    if (e === 1 && shouldRefresh) {
      setUpdateSolicitud((prev) => !prev);
    }
    dispatch(menu(e));
  };

  const componenteMostrar = () => {
    // Si ya se cargaron las sucursales pero no hay ninguna asignada
    if (sucursales.isFetched && sucursales.dataSucursales.length === 0) {
      return (
        <div
          className="d-flex justify-content-center align-items-center"
          style={{ minHeight: "400px" }}
        >
          <div className="text-center">
            <p className="mt-3">No hay sucursales asignadas.</p>
          </div>
        </div>
      );
    }

    // No renderizar componentes hasta que las sucursales estén cargadas
    if (!sucursales.isSucursal || !sucursalSelec.sucursalSeleccionada) {
      return (
        <div
          className="d-flex justify-content-center align-items-center"
          style={{ minHeight: "400px" }}
        >
          <div className="text-center">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Cargando...</span>
            </div>
            <p className="mt-3">Cargando información de sucursales...</p>
          </div>
        </div>
      );
    }

    switch (menuHome) {
      case 1:
        return <Solicitudes actualizaSolicitud={updateSolicitud} />;
      case 3:
        return <Dashboard />;
      case 5:
        return <Seguros actualizaSolicitud={updateSolicitud} />;
      default:
        return <Dashboard />;
    }
  };

  const seleccionSucursalBuscador = (data) => {
    if (data.length === 1) {
      const sucursalSelect = data[0].Clave;
      const dataSucursal = data[0];
      dispatch(updateSucursalSelection(dataSucursal));
      setSucursal(sucursalSelect);
    }
  };

  const sinSucursales =
    sucursales.isFetched && sucursales.dataSucursales.length === 0;

  const handleRefreshSucursales = async () => {
    const currentSecurityKey = getSecurityKey();
    try {
      const res = await geolocalizacion();
      await dispatch(
        getSucursales(user.correo, currentSecurityKey, res.lt, res.lg),
      );
    } catch (error) {
      console.error("Error al cargar sucursales:", error);
    }
  };

  return (
    <section className="seccion-home">
      <Container>
        <Row>
          <Col xs={4} className="col-menu-lateral">
            <img src={logoAtria} className="logo-atria-color" alt="Atria" />
            <ul className="opcion-menu">
              <li className="pb-3">
                <Typeahead
                  className="col"
                  id="basic-typeahead-single"
                  labelKey="Proveedor"
                  options={sucursales.dataSucursales}
                  defaultOpen={true}
                  placeholder="Buscar agencia por nombre"
                  minLength={1}
                  emptyLabel="No se encontraron coincidencias."
                  onChange={(item) => {
                    seleccionSucursalBuscador(item);
                  }}
                />
              </li>
              <li>
                <div className="form-floating select-sucursal">
                  {!sucursales.isSucursal ||
                  sucursales.dataSucursales.length === 0 ? (
                    <div className="d-flex align-items-center justify-content-between p-3 bg-warning bg-opacity-10 rounded">
                      <small className="text-muted">
                        No se pudieron cargar las sucursales
                      </small>
                      <button
                        className="btn btn-sm btn-outline-warning ms-2"
                        onClick={handleRefreshSucursales}
                        title="Reintentar cargar sucursales"
                        style={{ minWidth: "36px", padding: "4px 8px" }}
                      >
                        <IconRefresh size={16} stroke={2} />
                      </button>
                    </div>
                  ) : (
                    <>
                      <select
                        className="form-select"
                        id="floatingSelect"
                        value={sucursal}
                        onChange={cambioSucursal}
                      >
                        {optionSucursales}
                      </select>
                      <label
                        htmlFor="floatingSelect"
                        className="label-sucursal"
                      >
                        <i className="icon-pin-sucursal"></i>Sucursal
                      </label>
                    </>
                  )}
                </div>
              </li>
              <li className={`${vistaMostrar === 3 && "list-active"}`}>
                <i className="icon-trophy me-3"></i>
                <span
                  className="nav-link"
                  onClick={() => mostrarSolicidutes(3)}
                >
                  Dashboard
                </span>
                <span className="circle"></span>
              </li>
              <li className={`${vistaMostrar === 1 && "list-active"}`}>
                <i className="icon-solicitud"></i>
                <span
                  className="nav-link"
                  onClick={() => mostrarSolicidutes(1)}
                >
                  Solicitudes de Crédito
                </span>
                <span className="circle"></span>
              </li>
              <li>
                <i className="icon-add"></i>
                {sinSucursales ? (
                  <span
                    className="nav-link disabled"
                    style={{ opacity: 0.5, cursor: "not-allowed" }}
                    title="No tienes sucursales asignadas"
                  >
                    Nueva solicitud de Crédito
                  </span>
                ) : (
                  <NavLink
                    aria-current="page"
                    to="/cotizador"
                    onClick={() => mostrarSolicidutes(2)}
                    className="nav-link"
                  >
                    Nueva solicitud de Crédito
                  </NavLink>
                )}
              </li>

              <li className={`${vistaMostrar === 5 && "list-active"}`}>
                <i className="icon-seguros"></i>
                <span
                  className="nav-link"
                  onClick={() => mostrarSolicidutes(5)}
                >
                  Solicitudes de Seguros
                </span>
                <span className="circle"></span>
              </li>
              <li className={`${vistaMostrar === 4 && "list-active"}`}>
                <i className="icon-add"></i>
                {sinSucursales ? (
                  <span
                    className="nav-link disabled"
                    style={{ opacity: 0.5, cursor: "not-allowed" }}
                    title="No tienes sucursales asignadas"
                  >
                    Nuevo seguro de Contado
                  </span>
                ) : (
                  <NavLink
                    aria-current="page"
                    to="/cotizador-seguro"
                    onClick={() => mostrarSolicidutes(4)}
                    className="nav-link"
                  >
                    Nuevo seguro de Contado
                  </NavLink>
                )}
              </li>
            </ul>
            <img
              src={logoAtriaLateral}
              className="logo-atria-lateral"
              alt="Atria"
            />
            <NavLink
              to={"/login"}
              onClick={handleLogout}
              className="cerrar-sesion"
            >
              Cerrar Sesión
            </NavLink>
          </Col>
          <Col xs={8} className="col-contenido">
            {vistaMostrar === 1 || vistaMostrar === 5 ? (
              <div className="text-end mt-3">
                <img
                  src={require("../assets/images/logos/atria-color.png")}
                  alt="Atria"
                  className="logo-atria-color"
                />
              </div>
            ) : (
              <BarraPerfil nombre={fullName} imgProfile={profilePicture} />
            )}

            {
              /*vistaMostrar === 1 ? <Solicitudes actualizaSolicitud={updateSolicitud} />
                            : <Dashboard />*/
              componenteMostrar()
            }

            <Footer />
          </Col>
        </Row>
        <Loading show={loading} />
        <AlertaMessage
          show={obtencionAlerta.show}
          data={obtencionAlerta.data}
        />
        <ModalErrores
          show={isError}
          tipoError={tipoError}
          mensajeError={mensajeError}
        />
      </Container>
    </section>
  );
};

export default HomeScreen;
